<template>
  <div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <upload-alert :allowedFiles="allowedFiles" :allowedEncoding="allowedEncoding">
          <template v-slot:upload-alert-extra-information>
            <slot name="upload-alert-extra-information"></slot>
          </template>
        </upload-alert>
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <upload-area @files:change="filesChange" />
      </v-col>
    </v-row>
    <v-row class="mx-auto">
      <v-col cols="12">
        <general-progress-bars
          class="mb-11 mt-11"
          :items="uploadProgressData"
          prefixText="Enviando"
          suffixProperty="name"
          :includeHashOnText="false"
          :truncateText="true"
        />
        <upload-queue
          :files.sync="files"
          :formatoGdbAneel="formatoGdbAneel"
          :modulo10_antigo="modulo10_antigo"
          :uploadProgressData.sync="uploadProgressData"
          :dispatcherFile="dispatcherFile"
          :uploadFieldName="uploadFieldName"
          :uploadMethod="uploadMethod"
          :uploadPath="uploadPath"
          :validarArquivo="validarArquivo"
          @file:uploaded="handleFileUploaded"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import UploadAlert from '@/components/general/UploadFiles/UploadAlert.vue';
  import UploadArea from '@/components/general/UploadFiles/UploadArea.vue';
  import UploadQueue from '@/components/general/UploadFiles/UploadQueue.vue';
  import GeneralProgressBars from '@/components/general/GeneralProgressBars.vue';

  export default {
    name: 'UploadFiles',
    components: {
      UploadAlert,
      UploadArea,
      UploadQueue,
      GeneralProgressBars
    },
    props: {
      allowedFiles: {
        type: Array,
        default: () => []
      },
      allowedEncoding: {
        type: Array,
        default: () => []
      },
      dispatcherFile: {
        type: String,
        default: null
      },
      uploadFieldName: {
        type: String,
        default: 'arquivo'
      },
      uploadMethod: {
        type: String,
        default: 'upload'
      },
      uploadPath: {
        type: String,
        default: null
      },
      maxFiles: {
        type: Number,
        default: null
      },
      formatoGdbAneel: {
        type: Boolean,
        default: false
      },
      // eslint-disable-next-line vue/prop-name-casing
      modulo10_antigo: {
        type: Boolean,
        default: false
      },
      validarArquivo: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        files: [],
        uploadProgressData: {},
        uploadedFiles: []
      };
    },
    methods: {
      filesChange(file) {
        if (this.maxFiles && this.files.length + this.uploadedFiles.length >= this.maxFiles) {
          this.$toast.error(`Envie no máximo ${this.maxFiles} arquivos.`, '', { position: 'topRight' });
          return;
        }

        this.files.push(file);
      },
      handleFileUploaded(event) {
        const { files } = event;
        files.forEach((file) => this.uploadedFiles.push(file));
        this.$emit('file:uploaded', event);
      },
      removerArquivoEnviado(id) {
        this.uploadedFiles = this.uploadedFiles.filter((file) => file.id !== id);
      }
    }
  };
</script>
